import React, { useState, useEffect } from 'react'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { Form } from 'react-bootstrap'
import { CustomButton } from '../../components/CustomButton/index.jsx'

const MagaluAuthentication = () => {
  const [code, setCode] = useState('')
  const [state, setState] = useState('')
  const [magalus, setMagalus] = useState([])
  const [selectedMagalu, setSelectedMagalu] = useState('')

  const navigate = useNavigate()

  const CLIENT_ID = 'hTQomxrpRYXys5D7jFxNt_Io_8OYmncDZBbeYQSaaZE'
  const REDIRECT_URI = 'https://ziphub.com.br/magalu'

  useEffect(() => {
    ;(async () => {
      try {
        const response = await apinode.get(
          `/get-magalus/${localStorage.idconta}`,
        )

        setMagalus(response.data)
      } catch (err) {
        sendErrorApiMessage(
          err,
          'Erro ao buscar as contas do Magalu, tente novamente mais tarde',
        )
      }
    })()
  }, [])

  // Função para extrair o código da URL
  useEffect(() => {
    const url = window.location.href

    const urlParams = new URLSearchParams(url.split('?')[1])
    const codeParam = urlParams.get('code')
    const state_id = urlParams.get('state')

    setCode(codeParam)
    setState(state_id)
  }, [])

  // const extractParamsFromUrl = (url) => {

  //   const urlParams = new URLSearchParams(url.split('?')[1])

  //   // Verificar se há o parâmetro 'state' na URL
  //   if (urlParams.has('state')) {
  //     const stateParam = urlParams.get('state')

  //     // Dividir o parâmetro 'state' em partes usando o '&' como delimitador
  //     const stateParts = stateParam.split('&')

  //     // Procurar por 'state_id' dentro das partes divididas
  //     for (const part of stateParts) {
  //       if (part.includes('state_id')) {
  //         // Dividir novamente para obter o valor de 'state_id'
  //         const setState = part.split('=')[1]
  //         return setState
  //       }
  //     }
  //   }

  //   return null
  // }

  // Botão de consentimento: leva o state para a tela de login/autorização do Magalu
  const handleConsent = () => {
    const SCOPES =
      'open:portfolio-skus-seller:read open:order-order-seller:read'

    const authParams = new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri: REDIRECT_URI,
      scope: SCOPES,
      response_type: 'code',
      choose_tenants: 'true',
      state: localStorage.idconta || '',
    })

    window.location.href =
      'https://id.magalu.com/login?' + authParams.toString()
  }

  // Função para fazer a requisição ao Magalu
  const handleAuthentication = async () => {
    console.log(state)

    try {
      // const magaluTokenUrl = 'https://api.magalu.com.br/auth/token';
      const requestData = {
        code,
        state,
        nome_conta: selectedMagalu,
      }

      const response = await apinode.post(
        `/magalu/${localStorage.idconta}`,
        requestData,
      )

      console.log('Token de acesso:', response.data)
      toast.success(response.data.message)

      navigate('/')
    } catch (error) {
      toast.error(error.message)
      console.error('Erro ao obter token de acesso:', error.message)
    }
  }

  const hasCode = Boolean(code)

  return (
    <>
      <Navbar />

      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.brandRow}>
            <span style={styles.brandDot} />
            <span style={styles.brandName}>ZipHub</span>
            <span style={styles.brandTimes}>×</span>
            <span style={styles.magaluName}>Magalu</span>
          </div>

          <h3 style={styles.title}>Conectar loja Magalu</h3>
          <p style={styles.subtitle}>
            Autorize sua loja no ID Magalu para sincronizar portfólio e pedidos.
            Use as credenciais da loja (CNPJ / pessoa jurídica).
          </p>

          <div style={styles.steps}>
            <div style={styles.step}>
              <span
                style={{
                  ...styles.stepNum,
                  ...(hasCode ? styles.stepDone : styles.stepActive),
                }}
              >
                {hasCode ? '\u2713' : '1'}
              </span>
              <div>
                <div style={styles.stepTitle}>Autorizar no Magalu</div>
                <div style={styles.stepText}>
                  Login e consentimento na loja.
                </div>
              </div>
            </div>
            <div style={styles.stepLine} />
            <div style={styles.step}>
              <span
                style={{
                  ...styles.stepNum,
                  ...(hasCode ? styles.stepActive : styles.stepIdle),
                }}
              >
                2
              </span>
              <div>
                <div style={styles.stepTitle}>Concluir integração</div>
                <div style={styles.stepText}>Troca do código pelo token.</div>
              </div>
            </div>
          </div>

          <div style={styles.statusBox}>
            {hasCode ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 5,
                }}
              >
                {' '}
                <span style={styles.statusOk}>
                  &#9679; Código recebido da URL. Pode concluir.
                </span>
                <Form.Select
                  value={selectedMagalu}
                  onChange={(e) => setSelectedMagalu(e.target.value)}
                >
                  <option value="">Selecione a conta</option>
                  {magalus.map((mg) => (
                    <option value={mg.nome_conta}>{mg.apelido}</option>
                  ))}
                </Form.Select>
              </div>
            ) : (
              <span style={styles.statusWait}>
                &#9679; Aguardando autorização. Comece pelo passo 1.
              </span>
            )}
          </div>

          {!hasCode && (
            <button
              style={{ ...styles.btn, ...styles.btnPrimary }}
              onClick={handleConsent}
            >
              Autorizar com o ID Magalu
            </button>
          )}

          {hasCode && (
            <CustomButton
              onClick={handleAuthentication}
              isDisabled={!selectedMagalu}
              title="Continuar e concluir"
              style={{
                ...styles.btn,
                ...styles.btnSuccess,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          )}

          <p style={styles.footnote}>
            Após autorizar, o Magalu retorna para{' '}
            <strong>ziphub.com.br/magalu</strong> com o código de acesso.
          </p>
        </div>
      </div>
    </>
  )
}

const styles = {
  page: {
    minHeight: 'calc(100vh - 64px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(160deg, #0b1120 0%, #131c31 100%)',
    padding: '32px 20px',
  },
  card: {
    width: '100%',
    maxWidth: 440,
    background: '#ffffff',
    borderRadius: 18,
    padding: 34,
    boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  brandRow: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 },
  brandDot: {
    width: 9,
    height: 9,
    borderRadius: '50%',
    background: '#0086ff',
    boxShadow: '0 0 10px #0086ff',
  },
  brandName: { fontWeight: 700, color: '#0f172a', letterSpacing: '-0.01em' },
  brandTimes: { color: '#94a3b8', margin: '0 2px' },
  magaluName: { fontWeight: 700, color: '#0086ff' },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: '#0f172a',
    margin: '0 0 8px',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: 14,
    lineHeight: 1.55,
    color: '#64748b',
    margin: '0 0 26px',
  },
  steps: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 4,
    marginBottom: 22,
  },
  step: { display: 'flex', gap: 11, flex: 1 },
  stepLine: {
    width: 24,
    height: 2,
    background: '#e2e8f0',
    marginTop: 13,
    flexShrink: 0,
  },
  stepNum: {
    width: 26,
    height: 26,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 700,
    flexShrink: 0,
  },
  stepActive: { background: '#0086ff', color: '#fff' },
  stepDone: { background: '#2ec76a', color: '#fff' },
  stepIdle: { background: '#e2e8f0', color: '#94a3b8' },
  stepTitle: { fontSize: 13.5, fontWeight: 600, color: '#0f172a' },
  stepText: { fontSize: 12, color: '#94a3b8', lineHeight: 1.4, marginTop: 2 },
  statusBox: {
    background: '#f8fafc',
    border: '1px solid #eef2f7',
    borderRadius: 10,
    padding: '11px 14px',
    marginBottom: 18,
    fontSize: 13,
  },
  statusOk: { color: '#2ec76a', fontWeight: 500 },
  statusWait: { color: '#f59e0b', fontWeight: 500 },
  btn: {
    width: '100%',
    padding: '13px',
    border: 'none',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    color: '#fff',
    transition: 'opacity .15s',
  },
  btnPrimary: { background: '#0086ff' },
  btnSuccess: { background: '#2ec76a', textAlign: 'center' },
  footnote: {
    fontSize: 12,
    color: '#94a3b8',
    textAlign: 'center',
    lineHeight: 1.5,
    margin: '18px 0 0',
  },
}

export default MagaluAuthentication
